import { Component, OnInit } from '@angular/core';
import { SurveyService } from '../../services/survey.service';
import { Router } from '@angular/router';
import { LocalizedSurvey } from '../../models/questions';

@Component({
  selector: 'app-admin-survey-list',
  templateUrl: './admin-survey-list.component.html',
  styleUrls: ['./admin-survey-list.component.scss']
})
export class AdminSurveyListComponent implements OnInit {

  surveys: Array<LocalizedSurvey> = [];

  constructor(private surveyService: SurveyService, private router: Router) {
  }

  ngOnInit() {
    this.surveyService.getAll()
      .subscribe(results => this.surveys = results);
  }

  onSurveyClicked(survey: LocalizedSurvey) {
    this.router.navigate(['/admin/survey-editor', { id: survey.id }]);
  }

}
